import { BehaviorSubject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import DataTableRepository from '../Repositories/DataTableRepository'

class DataTableBloc {
    dataTableRepository = new DataTableRepository()
    
    rowtableChannel = new BehaviorSubject({
        status: apiResponse.INITIAL,
        data: []
    })

    deleteChannel = new BehaviorSubject({
        status: apiResponse.INITIAL,
        data: []
    })

    async fetchRowTable(query, cancelToken) {
        this.rowtableChannel.next({
            status: apiResponse.LOADING,
            data: []
        })

        try {
            const response = await this.dataTableRepository.fetchRowTable(query, cancelToken)
            this.rowtableChannel.next({
                status: apiResponse.COMPLETED,
                data: response
            })
        } catch (error) {
            this.rowtableChannel.next({
                status: apiResponse.ERROR,
                data: error
            })
        }
    }

    async fetchDelete(data, cancelToken) {
        this.deleteChannel.next({
            status: apiResponse.LOADING,
            data: []
        })

        try {
            const response = await this.dataTableRepository.fetchDelete(data)
            this.deleteChannel.next({
                status: apiResponse.COMPLETED,
                data: response
            })
        } catch (error) {
            this.deleteChannel.next({
                status: apiResponse.ERROR,
                data: error
            })
        }
    }
}

export default DataTableBloc
